import React from "react";
import "./DataPrivacy.css";

const DataPrivacy = () => {
  return (
    <div className="dataPrivacy_parent_div">
      <h1>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit
        perferendis pariatur optio non doloremque porro vel sequi quisquam iure,
        quo vero mollitia corporis sint quidem voluptatum accusantium nam,
        reiciendis animi.
      </h1>
    </div>
  );
};

export default DataPrivacy;
